// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__2xUIK","content":"styles_content__1PQPb","checkbox":"styles_checkbox__baaVZ","checkboxLabel":"styles_checkboxLabel__76JUY"};